import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdfIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 15.471,
	height: 18.999,
	viewBox: "0 0 15.471 18.999",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_1448",
			"data-name": "Rectangle 1448",
			width: 15.471,
			height: 18.999,
			fill: "none"
		})
	}) }), /* @__PURE__ */ _jsx("g", {
		id: "Group_4959",
		"data-name": "Group 4959",
		transform: "translate(-663.16 20.318)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_4958",
			"data-name": "Group 4958",
			transform: "translate(663.16 -20.318)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_4957",
				"data-name": "Group 4957",
				clipPath: "url(#clip-path)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8061",
						"data-name": "Path 8061",
						d: "M293.308,84.789h-.016c0-.056-.021-.115.016-.168Z",
						transform: "translate(-277.837 -80.163)",
						fill: "#92130d"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8062",
						"data-name": "Path 8062",
						d: "M12.312,21.163q0-3.746,0-7.493a1.3,1.3,0,0,1,.577-1.131,1.226,1.226,0,0,1,.7-.222H22.23a1.552,1.552,0,0,1,1.182.484c.171.179.353.347.53.521L26.1,15.439a1.2,1.2,0,0,1,.382.91q-.006,6.156,0,12.312a1.3,1.3,0,0,1-.743,1.241,1.373,1.373,0,0,1-.639.132H13.666a1.287,1.287,0,0,1-1.22-.744,1.237,1.237,0,0,1-.129-.574v-.984Z",
						transform: "translate(-11.663 -11.667)",
						fill: "#f5f5f5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8063",
						"data-name": "Path 8063",
						d: "M74.626,70.475a5.742,5.742,0,0,1-.231,1.414c-.042.158-.079.324-.127.484a.152.152,0,0,0,.019.13,9.9,9.9,0,0,0,.941,1.309.828.828,0,0,1,.1.131c.072.141.18.148.321.126a7.156,7.156,0,0,1,1.533-.107,2.014,2.014,0,0,1,.712.15.657.657,0,0,1,.444.577.457.457,0,0,1-.261.463,1.212,1.212,0,0,1-.676.118,3.177,3.177,0,0,1-1.756-.718.831.831,0,0,1-.14-.12.26.26,0,0,0-.294-.079,14.988,14.988,0,0,0-1.9.521.265.265,0,0,0-.142.108,14.1,14.1,0,0,1-.841,1.222,4.078,4.078,0,0,1-.633.641,1.444,1.444,0,0,1-.726.3.744.744,0,0,1-.33-.032.5.5,0,0,1-.3-.712,1.548,1.548,0,0,1,.481-.532,7.478,7.478,0,0,1,1.282-.74c.147-.073.293-.147.44-.218a.173.173,0,0,0,.087-.09q.613-1.309,1.115-2.665a.179.179,0,0,0,0-.132,5.841,5.841,0,0,1-.317-1.082,3.243,3.243,0,0,1-.032-1.162.525.525,0,0,1,.858-.328.921.921,0,0,1,.354.668,2.043,2.043,0,0,1,.016.354",
						transform: "translate(-66.583 -65.677)",
						fill: "#1da193"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8064",
						"data-name": "Path 8064",
						d: "M128.681,255.312v-1.364c0-.069.015-.089.085-.086.272.01.544-.016.816.017a1.079,1.079,0,0,1,1.019.875,1.973,1.973,0,0,1-.085,1.325,1.057,1.057,0,0,1-.964.684c-.269.017-.538,0-.807.013-.068,0-.065-.034-.065-.079q0-.7,0-1.385",
						transform: "translate(-121.902 -240.488)",
						fill: "#1da193"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8065",
						"data-name": "Path 8065",
						d: "M87.625,255.315v-1.364c0-.064.015-.084.079-.079.306.009.612-.014.918.016a.827.827,0,0,1,.787,1,.778.778,0,0,1-.809.744c-.136.008-.272.01-.408.008-.069,0-.09.017-.089.088v.956c0,.074-.016.1-.1.1a2.372,2.372,0,0,0-.306,0c-.068,0-.079-.022-.079-.085,0-.465,0-.923,0-1.386",
						transform: "translate(-83.007 -240.497)",
						fill: "#1da193"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8066",
						"data-name": "Path 8066",
						d: "M175.144,255.252v-1.364c0-.068.011-.094.088-.093.483,0,.965,0,1.448,0,.062,0,.09.01.079.079-.011.1.043.237-.021.293s-.188.016-.286.017H175.7c-.059,0-.079.014-.079.079q.006.362,0,.724c0,.059.018.073.074.072h.752c.071,0,.093.02.086.089a1.059,1.059,0,0,0,0,.2c.009.079-.025.1-.1.094-.237,0-.475,0-.712,0-.087,0-.1.026-.1.1v1.077c0,.079-.023.1-.1.1a2.537,2.537,0,0,0-.306,0c-.067,0-.079-.02-.079-.083.006-.467.006-.924.006-1.382",
						transform: "translate(-165.912 -240.425)",
						fill: "#1da193"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8067",
						"data-name": "Path 8067",
						d: "M129.63,132.773a11.725,11.725,0,0,0,1.114,1.469,12.277,12.277,0,0,0-1.879.488c.278-.647.548-1.283.765-1.957",
						transform: "translate(-122.076 -125.778)",
						fill: "#f5f5f5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8068",
						"data-name": "Path 8068",
						d: "M171.742,161.1a6.95,6.95,0,0,1,1.484-.1,1.11,1.11,0,0,1,.427.114.389.389,0,0,1,.222.428.4.4,0,0,1-.37.3,1.086,1.086,0,0,1-.436-.069,4.424,4.424,0,0,1-1.254-.6c-.024-.017-.056-.025-.072-.07",
						transform: "translate(-162.694 -152.517)",
						fill: "#f5f5f5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8069",
						"data-name": "Path 8069",
						d: "M75.664,181.618a7.686,7.686,0,0,1-.581.838,5.923,5.923,0,0,1-.4.453,1.344,1.344,0,0,1-.521.343.284.284,0,0,1-.367-.387,1.028,1.028,0,0,1,.3-.361,4.778,4.778,0,0,1,.938-.591q.272-.139.545-.275a.086.086,0,0,1,.082-.021",
						transform: "translate(-69.882 -172.046)",
						fill: "#f5f5f5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8070",
						"data-name": "Path 8070",
						d: "M132.694,76.241a5.817,5.817,0,0,1-.237-.84,3.087,3.087,0,0,1-.066-.921.759.759,0,0,1,.092-.289.244.244,0,0,1,.255-.148.29.29,0,0,1,.245.2,1.227,1.227,0,0,1,.032.506,7.5,7.5,0,0,1-.319,1.492",
						transform: "translate(-125.407 -70.141)",
						fill: "#f5f5f5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8071",
						"data-name": "Path 8071",
						d: "M137.832,262.206c0-.316,0-.633,0-.955,0-.1.03-.127.123-.116s.158,0,.231.012a.652.652,0,0,1,.56.475,1.8,1.8,0,0,1,0,1.147.669.669,0,0,1-.695.5c-.215.006-.215.006-.215-.2Z",
						transform: "translate(-130.571 -247.375)",
						fill: "#f5f5f5"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_8072",
						"data-name": "Path 8072",
						d: "M97.025,260.824c.071,0,.142.012.213.014a.384.384,0,0,1,.349.33.808.808,0,0,1,0,.351.372.372,0,0,1-.347.309,2.77,2.77,0,0,1-.38.017c-.044,0-.059-.016-.059-.059v-.9c0-.044.013-.061.059-.058s.112,0,.167,0Z",
						transform: "translate(-91.7 -247.084)",
						fill: "#f5f5f5"
					})
				]
			})
		})
	})]
});
export { SvgPdfIcon as ReactComponent };
